import DashboardLayout from '../layouts/DashboardLayout'

export const policyPartnerMenu = {
  path: '/partner/policy-partner',
  component: DashboardLayout,
  name: 'Policy Partner',
  redirect: '/partner/policy-partner',
  children: [
    {
      path: '/',
      name: 'Policy Partner',
      component: () => import (/* webpackChunkName: "about" */'../pages/policy-partner/PolicyPartner'),
      meta: {
        requiresAuth: true,
        roles: ['partner-policy_read'],
        breadcrumb: [{
          title: 'Chính sách CTV'
        }]
      },
    }
  ],
}